import { render } from "./propertiesHtml.vue?vue&type=template&id=d2a98d8c"
import script from "./propertiesHtml.vue?vue&type=script&lang=js"
export * from "./propertiesHtml.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__